var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.response),function(component,index){return _c('div',{key:index},[_c(_vm.mappedComponent(component),{tag:"component",attrs:{"fields":component.fields,"type":component.type}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }